import type { ReactNode } from 'react';

import InfoPopover from '@/components/InfoPopover';
import { Text } from '@/components/typography';
import { cn } from '@/lib/utils';

type PanelHeaderProps = {
  title: ReactNode;
  infoPopover?: {
    title?: ReactNode;
    body: ReactNode;
  };
  actions?: ReactNode;
  headerClassName?: string | false;
  actionsClassName?: string | false;
};

const PanelHeader = ({
  title,
  infoPopover,
  actions,
  headerClassName = '',
  actionsClassName = '',
}: PanelHeaderProps) => (
  <div
    className={cn(
      'flex flex-row items-center justify-between bg-gray-300 px-8 py-5',
      actions ? 'pe-4' : '',
      headerClassName,
    )}
  >
    <Text className="flex flex-1 items-center gap-1 leading-6!" variant="label" weight="regular">
      {title}
      {infoPopover && <InfoPopover title={infoPopover.title ?? title} body={infoPopover.body} />}
    </Text>
    {actions && (
      <div className={cn('flex max-h-6 items-center gap-1', actionsClassName)}>{actions}</div>
    )}
  </div>
);

export default PanelHeader;
